import React from "react";

const ArtTabs = ({ activeTab, setActiveTab, language, movies, books, games }) => {
  const tabs = [
    { key: "movie", label: language === "ru" ? "Фильмы" : "Movies", count: movies?.length },
    { key: "book", label: language === "ru" ? "Книги" : "Books", count: books?.length },
    { key: "videoGame", label: language === "ru" ? "Игры" : "Games", count: games?.length },
  ];

  return (
    <div className="flex justify-center items-center gap-3">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.key;
        return (
          <div
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-5 py-2 rounded-xl text-sm font-medium transition-all cursor-pointer border backdrop-blur-sm
              ${isActive
                ? "bg-gray-700 border-gray-500 text-white shadow-md"
                : "bg-gray-800 border-gray-600 text-gray-300 hover:bg-gray-700 hover:text-white"}
            `}
          >
            {tab.label}
            {tab.count !== undefined && ` (${tab.count})`}
          </div>
        );
      })}
    </div>
  );
};

export default ArtTabs;
